var _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgEinforma = function SvgEinforma(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2056ce",
    width: "170.000000pt",
    height: "170.000000pt",
    viewBox: "0 0 170.000000 170.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,170.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M263 961 c-92 -34 -183 -109 -183 -152 0 -63 55 -89 192 -89 148 1 211 28 224 96 7 39 -26 106 -67 137 -38 28 -104 31 -166 8z m185 -64 c6 -5 12 -20 12 -33 0 -23 -3 -24 -60 -24 -54 0 -60 -2 -60 -20 0 -27 43 -44 71 -29 33 17 46 4 15 -16 -38 -25 -94 -25 -112 0 -22 30 -17 78 10 104 39 37 90 44 124 18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M357 884 c-15 -16 -5 -24 29 -24 24 0 34 4 32 13 -5 13 -50 22 -61 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M532 968 c7 -19 38 -22 38 -4 0 10 -9 16 -21 16 -12 0 -19 -5 -17 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M822 968 c-5 -7 -13 -23 -16 -35 -4 -13 -14 -23 -22 -23 -8 0 -14 -4 -14 -10 0 -5 7 -10 15 -10 12 0 15 -14 15 -65 0 -51 3 -65 15 -65 12 0 15 14 15 65 0 63 1 65 25 65 14 0 25 5 25 10 0 6 -11 10 -25 10 -18 0 -25 5 -25 19 0 23 25 47 35 31 9 -15 35 -12 35 5 0 19 -63 21 -78 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M539 850 c-1 -33 -2 -66 -3 -72 -1 -7 7 -14 17 -16 15 -3 17 6 17 72 0 61 -3 76 -15 76 -11 0 -15 -14 -16 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M610 833 c0 -66 2 -73 20 -73 17 0 19 7 19 53 -1 77 -1 77 30 77 34 0 41 -14 41 -81 0 -37 4 -49 15 -49 12 0 15 13 15 59 0 77 -13 90 -85 88 l-55 -1 0 -73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M903 884 c-49 -49 -8 -124 69 -124 47 0 88 35 88 75 0 69 -104 102 -157 49z m99 -1 c36 -32 15 -113 -29 -113 -46 0 -70 74 -36 112 20 22 41 23 65 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M1090 834 c0 -58 3 -74 15 -74 10 0 15 16 17 63 l3 62 33 -3 c24 -2 32 2 30 10 -3 8 -24 13 -51 14 l-47 1 0 -73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M1210 834 c0 -67 2 -74 20 -74 16 0 19 8 22 63 3 62 3 62 33 62 30 0 30 0 33 -62 2 -46 7 -63 17 -63 10 0 15 17 17 63 3 62 3 62 33 62 30 0 30 0 33 -62 3 -55 6 -63 22 -63 17 0 20 7 20 54 0 75 -22 102 -76 91 -21 -5 -43 -7 -49 -5 -5 2 -36 5 -67 6 l-58 3 0 -75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2056ce",
    fillRule: "nonzero",
    d: "M1505 897 c-10 -8 -15 -19 -11 -25 11 -18 23 -14 29 9 7 28 51 23 55 -7 2 -16 -5 -23 -37 -33 -46 -13 -69 -44 -50 -67 7 -9 31 -14 65 -14 l54 0 0 63 c0 36 -5 68 -12 75 -16 16 -70 15 -93 -1z m73 -89 c-2 -28 -7 -33 -28 -33 -34 0 -40 37 -8 53 35 17 40 14 36 -20z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEinforma, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/einforma.9094a6d2.svg";
export { ForwardRef as ReactComponent };